var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatassistanImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2550_8921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93155 29.2442C6.02566 41.2011 18.1434 48.4858 29.9975 45.5154C29.9975 45.5154 41.9193 42.4389 46.6776 45.2995C46.6776 45.2995 43.6886 35.4651 45.3283 31.502C46.746 27.4687 47.0186 22.9675 45.8589 18.4864C42.7648 6.52954 30.6471 -0.755466 18.793 2.21531C6.93886 5.18575 -0.162561 17.287 2.93155 29.2442Z",
    fill: "url(#paint0_linear_2550_8921)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2746 19.5833C9.98432 21.3721 9.52124 25.2387 10.1444 29.2611C10.1727 29.445 9.89845 29.568 9.69405 29.4638L8.52303 28.8657C8.38393 28.7946 8.29379 28.6825 8.27499 28.5575C8.1295 27.5773 7.55002 23.1595 8.42048 20.1513C8.45525 20.0314 8.55426 19.9275 8.69655 19.866L9.84202 19.3711C10.0485 19.2819 10.303 19.4067 10.2742 19.5833H10.2746Z",
    fill: "url(#paint1_linear_2550_8921)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6113 19.5833C38.9015 21.3721 39.3646 25.2387 38.7415 29.2611C38.7131 29.445 38.9874 29.568 39.1918 29.4638L40.3628 28.8657C40.5019 28.7946 40.592 28.6825 40.6109 28.5575C40.7563 27.5773 41.3358 23.1595 40.4654 20.1513C40.4306 20.0314 40.3316 19.9275 40.1893 19.866L39.0438 19.3711C38.8373 19.2819 38.5829 19.4067 38.6116 19.5833H38.6113Z",
    fill: "url(#paint2_linear_2550_8921)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4031 14.6732C24.4031 14.6732 18.581 14.65 14.9118 15.2299C14.6613 15.2696 14.4785 15.4791 14.4785 15.7234V16.5659C14.4785 16.8666 14.7514 17.0997 15.0615 17.0624C16.5622 16.8823 20.6998 16.4302 24.4031 16.4302C28.1063 16.4302 32.2443 16.8823 33.7446 17.0624C34.0544 17.0997 34.3276 16.8666 34.3276 16.5659V15.7234C34.3276 15.4791 34.1449 15.2696 33.8944 15.2299C30.2252 14.65 24.4031 14.6732 24.4031 14.6732Z",
    fill: "url(#paint3_linear_2550_8921)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3121 32.8277C27.71 33.1349 21.098 33.1349 14.4956 32.8277C12.023 32.7125 10.017 30.7003 9.81116 28.1286C9.62805 25.8381 9.62805 23.5354 9.81116 21.245C10.017 18.6729 12.023 16.6607 14.4956 16.5459C21.0977 16.2386 27.7097 16.2386 34.3121 16.5459C36.7847 16.661 38.7907 18.6733 38.9965 21.245C39.1796 23.5354 39.1796 25.8381 38.9965 28.1286C38.7907 30.7006 36.7847 32.7128 34.3121 32.8277Z",
    fill: "url(#paint4_linear_2550_8921)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M38.9987 21.245C38.9238 20.309 38.6098 19.4481 38.1222 18.7246C38.2745 21.0639 38.2588 23.4121 38.0718 25.7493C37.8401 28.6433 35.5832 30.9078 32.8008 31.0373C25.5362 31.3753 18.261 31.3821 10.9961 31.0588C11.8545 32.093 13.1018 32.7628 14.4978 32.8277C21.0999 33.135 27.7119 33.135 34.3143 32.8277C36.7869 32.7126 38.7929 30.7003 38.9987 28.1286C39.1818 25.8382 39.1818 23.5355 38.9987 21.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8872 20.604H33.9205C34.8779 20.604 35.6554 21.3528 35.6554 22.2748V24.8517C35.6554 25.7737 34.8779 26.5225 33.9205 26.5225H14.8872C13.9298 26.5225 13.1523 25.7737 13.1523 24.8517V22.2748C13.1523 21.3528 13.9298 20.604 14.8872 20.604Z",
    fill: "url(#paint5_linear_2550_8921)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9202 21.1384H14.8869C14.2353 21.1384 13.707 21.6472 13.707 22.2748V24.8516C13.707 25.4792 14.2353 25.9879 14.8869 25.9879H33.9202C34.5719 25.9879 35.1001 25.4792 35.1001 24.8516V22.2748C35.1001 21.6472 34.5719 21.1384 33.9202 21.1384Z",
    fill: "url(#paint6_linear_2550_8921)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5702 23.9341C21.7824 23.4504 21.5473 22.8926 21.0451 22.6882C20.5429 22.4838 19.9637 22.7102 19.7515 23.1938C19.5392 23.6775 19.7743 24.2353 20.2765 24.4397C20.7787 24.6441 21.3579 24.4177 21.5702 23.9341Z",
    fill: "url(#paint7_linear_2550_8921)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3006 24.5C28.8387 24.4159 29.2042 23.9275 29.1168 23.4092C29.0295 22.8909 28.5224 22.5389 27.9842 22.6231C27.446 22.7072 27.0806 23.1956 27.1679 23.7139C27.2553 24.2322 27.7624 24.5841 28.3006 24.5Z",
    fill: "url(#paint8_linear_2550_8921)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M14.8869 21.1384C14.2354 21.1384 13.707 21.6473 13.707 22.2748V24.8516C13.707 25.3994 14.1094 25.8563 14.6453 25.964C20.774 25.7446 26.3778 23.9705 30.8107 21.1388H14.8869V21.1384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.59 28.6285L24.4858 28.7472C24.7658 28.7828 25.0336 28.8058 25.2935 28.8057C25.5542 28.8069 25.8063 28.7839 26.0666 28.7285C26.3295 28.6764 26.5926 28.5803 26.9025 28.471C26.7916 28.7697 26.5648 29.024 26.2746 29.1941C25.985 29.3657 25.6364 29.4525 25.2978 29.4486C24.9576 29.4482 24.6274 29.3666 24.3343 29.228C24.043 29.0873 23.7763 28.8965 23.59 28.6285Z",
    fill: "url(#paint9_linear_2550_8921)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2550_8921",
    x1: 64.3247,
    y1: 60.5966,
    x2: -6.8973,
    y2: -5.90783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D4D80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2550_8921",
    x1: 7.95136,
    y1: 24.4216,
    x2: 10.2771,
    y2: 24.4216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2550_8921",
    x1: 38.6088,
    y1: 24.4216,
    x2: 40.9345,
    y2: 24.4216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3C3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2550_8921",
    x1: 24.4031,
    y1: 14.6729,
    x2: 24.4031,
    y2: 16.5228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2550_8921",
    x1: 24.4038,
    y1: 16.3692,
    x2: 24.4038,
    y2: 33.2863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2550_8921",
    x1: 24.4041,
    y1: 26.6653,
    x2: 24.4041,
    y2: 20.3795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2550_8921",
    x1: 24.4038,
    y1: 21.2905,
    x2: 24.4038,
    y2: 26.0812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3C3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2550_8921",
    x1: 19.9638,
    y1: 22.891,
    x2: 21.307,
    y2: 24.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07DFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0199FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2550_8921",
    x1: 27.4432,
    y1: 22.8905,
    x2: 28.7867,
    y2: 24.2855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07DFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0199FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2550_8921",
    x1: 24.6402,
    y1: 29.5908,
    x2: 25.7002,
    y2: 27.7031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3C3B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2550_8921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.7059,
    height: 46,
    fill: "white",
    transform: "translate(0.0859375 0.865479)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatassistanImg);
export default __webpack_public_path__ + "static/media/chatassistan-img.2748e6cad2f7530d0cb6414f1f5ebbe2.svg";
export { ForwardRef as ReactComponent };